import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import cx from "classnames";
import s from "./Intro.module.scss";

import BgImg from "assets/images/2024-ui/background-1.jpg";
import Ribbon from "assets/images/2024-ui/red-ribbon.png";
import useQuery from "hooks/useQuery";

import BackgroundCorners from "components/BackgroundCorners";

Intro.defaultProps = {};
const SLIDES = {
  yeti: [
    {
      img: require("assets/images/2024-ui/intro-img-yeti.png").default,
      copy: {
        en: require("assets/images/en/intro/intro-copy-1.png").default,
        es: require("assets/images/es/intro/intro-copy-1.png").default,
      },
      copyAltText: {
        en: "Let’s head to AT&T for the best gifts​!",
        es: "Dirígete a AT&T para los mejores regalos.",
      }
    },
  ],
  bear: [
    {
      img: require("assets/images/2024-ui/intro-img-bear.png").default,
      copy: {
        en: require("assets/images/en/intro/intro-copy-1.png").default,
        es: require("assets/images/es/intro/intro-copy-1.png").default,
      },
      copyAltText: {
        en: "Let’s head to AT&T for the best gifts​!",
        es: "Dirígete a AT&T para los mejores regalos.",
      }
    },
  ],
  seal: [
    {
      img: require("assets/images/2024-ui/intro-img-seal.png").default,
      copy: {
        en: require("assets/images/en/intro/intro-copy-1.png").default,
        es: require("assets/images/es/intro/intro-copy-1.png").default,
      },
      copyAltText: {
        en: "Let’s head to AT&T for the best gifts​!",
        es: "Dirígete a AT&T para los mejores regalos.",
      }
    },
  ]
}

const translate = {
  skipLink: {
    en: "Skip",
    es: "Saltar"
  }
}

export default function Intro({ onComplete }) {
  const lang = useQuery().get("lang") || "en";
  const character = useSelector((state) => state.game.character);
  const [killMe,setKillMe] = useState(null);
  const [slide, setSlide] = useState(0);

  useEffect(() => {
    if (slide <= SLIDES[character].length) {
      setKillMe(setTimeout(() => {
        if (slide < SLIDES[character].length - 1) {
          setSlide(slide + 1);
        } else {
          // onComplete();
          killIt();
        }
      }, 3000));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide]);

  const killIt = () => {
    clearTimeout(killMe);
    onComplete();
  }

  const getSlides = (index) => {
    return (
      <>
        <div className={s.imageWrapper}>
          {SLIDES[character].map((characterSlide, i) => (
            <img
              src={characterSlide.img}
              alt=""
              className={cx(s.story, { [s.active]: i === index })}
              key={`slide-img-${i}`}
            />
          ))}
        </div>
        <div className={s.textWrapper}>
          <img src={Ribbon} alt="" className={cx(s.ribbon, s.active)} />
          {SLIDES[character].map((characterSlide, i) => (
            <img
              src={characterSlide.copy[lang]}
              alt={characterSlide.copyAltText[lang]}
              className={cx(s.story, { [s.active]: i === index })}
              key={`copy-img-${i}`}
            />
          ))}
        </div>
      </>
    );
  }

  return (
    <div className={s.Intro}>
      <div className={s.background}>
        <img src={BgImg} alt="" className={s.bg} />
        <BackgroundCorners className={s.corners} />
      </div>
      <div className={s.content}>
        {getSlides(slide)}
        <button className={cx(s.skip, "link")} onClick={killIt}>
          {translate.skipLink[lang]}
        </button>
      </div>
    </div>
  );
}
